import { GlobalModal } from "./GlobalModal";
import { GlobalButton } from "./forms/GlobalFormFields";
import "./GlobalSuccessFlashModal.css";

/**
 * Success dialog: opens while `message` is non-empty. Dismiss with OK.
 */
export default function GlobalSuccessFlashModal({
  message,
  onDismiss,
  title = "Success",
  okLabel = "OK",
  tone = "success",
}) {
  const open = Boolean(message && String(message).trim());
  const toneClass =
    tone === "warning" ? "gsf-success-flash--warning" : "gsf-success-flash--success";

  return (
    <GlobalModal
      open={open}
      onClose={onDismiss}
      title={title}
      size="sm"
      closeOnBackdrop={false}
      closeOnEscape={false}
      showCloseButton={false}
      classNames={{
        modal: `gff-modal gsf-success-flash ${toneClass}`.trim(),
        header: "gff-modal__header gsf-success-flash__header",
        title: "gff-modal__title gsf-success-flash__title",
        body: "gff-modal__body gsf-success-flash__body",
        footer: "gff-modal__footer gsf-success-flash__footer",
      }}
      footer={
        <GlobalButton variant="primary" type="button" onClick={onDismiss}>
          {okLabel}
        </GlobalButton>
      }
    >
      <p className="gsf-success-flash__msg">{message}</p>
    </GlobalModal>
  );
}
